import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { ApiUrls } from 'src/app/shared/const/Api-urls';
import { PageCategoryCO, PageCategoryType, PageCO } from 'src/app/shared/models/ApiModels';
import { PageDataService } from 'src/app/shared/services/page-data.service';

@Component({
  selector: 'app-facilities',
  templateUrl: './facilities.component.html',
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent implements OnInit,AfterViewInit, OnDestroy {

  loading$ = this.pageDataService.loading$;
  error$ = this.pageDataService.error$;

  @ViewChild('facilityCarousel') facilityCarousel!: ElementRef<HTMLDivElement>;

  facilities = [
    { title: 'School Bus', image: 'assets/bus.jpg', desc: 'Safe transport.' },
    { title: 'Library', image: 'assets/library.jpg', desc: 'Reading space.' },
    { title: 'Class Room', image: 'assets/classroom.jpg', desc: 'Modern rooms.' },
    { title: 'Laboratory', image: 'assets/lab.jpg', desc: 'Practical labs.' },
     { title: 'Laboratory1', image: 'assets/lab.jpg', desc: 'Practical labs.' },
      { title: 'Laboratory2', image: 'assets/lab.jpg', desc: 'Practical labs.' },
       { title: 'Laboratory3', image: 'assets/lab.jpg', desc: 'Practical labs.' },

  ];

  congiguredFacilities:any=[];

  infiniteFacilities = [...this.facilities, ...this.facilities];

  private animationId: number | null = null;
  private speed = 3; // pixels per frame

  constructor(private pageDataService: PageDataService) {}

  ngAfterViewInit() {
    this.play();
  }

  play() {
    const el = this.facilityCarousel.nativeElement;
    console.log(el.scrollWidth);

    const step = () => {
      el.scrollLeft += this.speed;
      // console.log( el.scrollLeft, el.scrollWidth / 2);
      if (el.scrollLeft >= el.scrollWidth / 2) {
        console.log('Resetting scroll');
        el.scrollLeft = 0;
      }

      // seamless reset
      if (el.scrollLeft >= el.scrollWidth /2) {
        el.scrollLeft = 0;
      }

      this.animationId = requestAnimationFrame(step);
    };

    this.animationId = requestAnimationFrame(step);
    console.log("play called");
  }

  pause() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }

  ngOnDestroy() {
    this.pause();
  }

  ngOnInit(): void {
        this.pageDataService.loadPageData();
      }
  
       pageData$ = this.pageDataService.pageData$.pipe(
          tap(data => {
            console.log("data length:" + data?.length);
            if (data?.length ) {
              this.extractImages(data[0]);
            }
          })
        );
      private extractImages(page: PageCO): void {
              if (!page.category?.length) return;
          
              const categoryMap = new Map<PageCategoryType, PageCategoryCO>();
              page.category.forEach(cat => categoryMap.set(cat.category, cat));
          
              this.congiguredFacilities = this.buildImageList(
                categoryMap.get(PageCategoryType.FACILITIES)
              );
            }
    
             private buildImageList(category?: PageCategoryCO): any[] {
                return (
                  category?.image?.map(img =>({
                    fileUrl:this.getFileUrl(img.file.fileUUID),
                    title:img.file?.title||'',
                    desc:img.descp||''
             })) ?? []
                );
              }
            
              private getFileUrl(uuid: string): string {
                return `${ApiUrls.downloadFileUrl1}${uuid}`;
              }
    
  
}
